import styles from './OffersAchieving.module.scss';
import OffersAchievingList from './List/OffersAchievingList';

export default function OffersAchieving({ blockTitle, blockText, items }) {
  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title} data-aos="fade-up">
        {blockTitle || 'Browse the latest offers'}
      </h2>
      <div
        className={styles.text}
        data-aos="fade-up"
        dangerouslySetInnerHTML={{ __html: blockText || '' }}
      />
      <OffersAchievingList items={items} />
    </div>
  );
}
